import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

/**
 * Internal per-line item note entered at cart checkout (host only).
 */
export default function OrderItemStaffNote({ item, sx }) {
  const { t } = useTranslation();
  const { isInternal } = useAuth();
  const note = item?.staffNote != null ? String(item.staffNote).trim() : '';
  if (!isInternal || !note) return null;
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      display="block"
      sx={{ fontStyle: 'italic', ...sx }}
    >
      {t('orders.itemStaffNote')}: {note}
    </Typography>
  );
}
